
import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '口座開設に費用はかかりますか？',
      answer: '口座開設・維持費用は完全無料です。口座を持っているだけでは一切費用はかかりません。取引時のスプレッド（売値と買値の差）のみが実質的なコストとなります。',
    },
    {
      question: '審査にはどのくらい時間がかかりますか？',
      answer: 'スマホでスピード本人確認を利用した場合、最短即日で審査完了します。画像アップロードの場合は1〜2営業日程度です。土日祝日は審査が行われないため、金曜日の申し込みは翌週になる場合があります。',
    },
    {
      question: '学生や主婦でも口座開設できますか？',
      answer: '18歳以上で日本国内に居住していれば、学生や主婦の方でも口座開設可能です。職業欄で「学生」「主婦」を選択できます。ただし、投資経験や金融資産に関する質問がありますので、正直にご回答ください。',
    },
    {
      question: '複数の口座を持つことはできますか？',
      answer: 'DMM FXでは1人1口座までとなっています。ただし、DMM FXとDMM CFDなど、異なるサービスの口座はそれぞれ開設可能です。',
    },
    {
      question: '最低いくらから取引できますか？',
      answer: 'DMM FXの最低取引単位は10,000通貨です。米ドル/円の場合、レバレッジ25倍を利用すれば約6万円程度から取引を始められます。',
    },
    {
      question: '口座開設の申し込みを途中でやめた場合はどうなりますか？',
      answer: '途中で中断しても問題ありません。入力した情報は一定期間保存されるため、後から続きを入力することも可能です。再度最初から申し込むこともできます。',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">よくある質問</h2>
          <p className="text-gray-600">口座開設に関する疑問にお答えします</p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((faq, index) => (
            <div
              key={index}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="bg-white rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 itemProp="name" className="text-sm font-bold text-gray-900 flex items-center gap-3 pr-4">
                  <span className="w-7 h-7 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0">
                    <i className="ri-question-line text-teal-600 text-sm"></i>
                  </span>
                  {faq.question}
                </h3>
                <i className={`ri-arrow-down-s-line text-gray-400 text-xl transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                  className="px-5 pb-5"
                >
                  <p itemProp="text" className="text-sm text-gray-700 leading-relaxed pl-10">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
